import styled from 'styled-components';
import { ContentSpacing } from '@estee/elc-base-theme';
import { Button } from '@estee/elc-buttons';
// import { Button } from '@elc-online/edl-react';
import { CTALink } from '../product-brief/CTALink';

export const CTAButtonWrapper = styled.div`
    width: 100%;
`;

export const StyledCTALink = styled(CTALink)`
    margin-top: ${ContentSpacing.space8};
`;

export const StyledButton = styled(Button)`
    width: 100%;
    border: none;
    padding: 0 ${ContentSpacing.space16};
    overflow-x: hidden;
    cursor: pointer;
`;

export const StyledJoinNowButton = styled(Button)`
    width: 100%;
    border: none;
    padding: 0 ${ContentSpacing.space16};
    overflow-x: hidden;
    cursor: pointer;
`;

export const StyledSignInButton = styled(Button)`
    width: 100%;
    border: none;
    padding: 0 ${ContentSpacing.space16};
    overflow-x: hidden;
    cursor: pointer;
`;

export const StyledShopNowButton = styled(Button)`
    width: 100%;
    margin-right: ${ContentSpacing.space16};
    height: 40px;

    [dir='rtl'] & {
        margin-left: ${ContentSpacing.space16};
        margin-right: 0;
    }
`;

export const StyledAddToBagButton = styled(Button)`
    margin-right: ${ContentSpacing.space16};
    height: 40px;
    padding: ${ContentSpacing.space10};

    [dir='rtl'] & {
        margin-left: ${ContentSpacing.space16};
        margin-right: 0;
    }
`;
